import { render, staticRenderFns } from "./SoftwareComponentVersionSingleEdit.vue?vue&type=template&id=e7b066dc&scoped=true&"
import script from "./SoftwareComponentVersionSingleEdit.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentVersionSingleEdit.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentVersionSingleEdit.vue?vue&type=style&index=0&id=e7b066dc&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b066dc",
  null
  
)

export default component.exports